<div class="page-container">
  <div class="header-container" *ngIf="!isCreationFolder(); else creationFolderHeader">
    <div data-cy="version-version-history-vessel-name">
      {{ vessel.name }}
    </div>
    <div class="version-number">
      <div>
        {{ 'versions-history.changes.header.version.prefix' | translate }}
      </div>
      <div data-cy="version-version-history-version-number">
        {{ version?.name }}
      </div>
      <ng-container *ngIf="!version?.publishedDate">
        {{ 'versions-history.changes.version.current-version' | translate }}
      </ng-container>
    </div>
    <div>
      {{ 'versions-history.changes.header.explanation' | translate }}
    </div>
  </div>
  <ng-container *ngIf="version && !projectIsActive() && !isCreationFolder()">
    <div class="restore-version-button" (click)="restoreVersion(version)">
      {{ 'versions-history.sidebar.button.restore' | translate }}
    </div>
  </ng-container>
  <div class="changes-container" #changesContainer>
    <ng-container *ngIf="version && !isCreationFolder()">
      <div *ngIf="version?.publishedDate && !isLoadingChanges" class="uploaded-container">
        <mat-icon svgIcon="spaceship" />
        <div class="uploaded-text-container">
          <div data-cy="version-version-history-upload-successful-text-1">
            {{ 'versions-history.changes.approved.title.1' | translate: { version: version.name } }}
          </div>
          <div class="small-text" data-cy="version-version-history-upload-successful-text-2">
            {{ 'versions-history.changes.approved.title.2' | translate: { version: version.name } }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="isLoadingChanges">
  <app-loading-spinner class="spinner-component"></app-loading-spinner
></ng-container>

<ng-template #creationFolderHeader>
  <div class="header-container">
    <div>{{ vessel.name }}</div>
    <div class="version-number">
      <div>
        {{ 'versions-history.sidebar.name.folder' | translate }}
      </div>
    </div>
  </div>
</ng-template>
